import api from './api';

export const inviteService = {
  /**
   * Create and send an organization invite
   */
  createInvite: async (organizationId, inviteData) => {
    const response = await api.post(`/api/invites?organization_id=${organizationId}`, inviteData);
    return response.data;
  },

  /**
   * Get invite details by token (public endpoint)
   */
  getInviteByToken: async (token) => {
    const response = await api.get(`/api/invites/${token}`);
    return response.data;
  },

  /**
   * Accept an organization invite
   */
  acceptInvite: async (token) => {
    const response = await api.post('/api/invites/accept', { token });
    return response.data;
  },

  /**
   * Cancel/delete a pending invite
   */
  cancelInvite: async (inviteId, organizationId) => {
    const response = await api.delete(`/api/invites/${inviteId}`, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  /**
   * Resend an invite email
   */
  resendInvite: async (inviteId, organizationId) => {
    const response = await api.post(`/api/invites/${inviteId}/resend`, null, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },
};

